import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'di-grid-error-row-renderer',
  templateUrl: './grid-error-row-renderer.component.html',
  host: {
    class: 'tw:block tw:bg-red-100 tw:py-2.5 tw:pl-2.5 tw:text-red-800',
  },
  standalone: false,
})
export class GridErrorRowRendererComponent implements ICellRendererAngularComp {
  errorMessage: string | undefined;
  params: ICellRendererParams;

  agInit(params: ICellRendererParams): void {
    this.params = params;

    this.setErrorMessage();
  }

  refresh(): boolean {
    this.setErrorMessage();

    return false;
  }

  private setErrorMessage(): void {
    const error = this.params.data.error;
    if (!error) {
      this.errorMessage = error;
      return;
    }
    const lines = error
      .split('\n')
      .map((line) => line.trim())
      .filter(Boolean);
    const uniqueLines = [...new Set(lines)];
    this.errorMessage = uniqueLines.join('\n');
  }
}
